import { ActionButton, DefaultButton, PrimaryButton } from "@fluentui/react";
import React, { Fragment, FunctionComponent, MouseEvent, useState } from "react";
import { Link } from "react-router-dom";
import { Action } from "redux";
import { respondToInvite } from "src/groups/groups-api";
import { localize } from "src/l10n";
import { Loader } from "src/ui";
import { removeNotification } from "../actions";
import { queryConversations } from "src/chat";
import { SpintrTypes } from "src/typings";

interface IProps {
    notification: Spintr.INotification;
    history: any;
    dispatch: (action: Action) => void;
}

const GroupInvitationNotification: FunctionComponent<IProps> = (props) => {
    const [ isLoading, setIsLoading ] = useState(false);

    const notification = props.notification as Spintr.IGroupInvitationNotification;
    if (!notification) {
        return null;
    }

    const respond = async (accepted: boolean): Promise<void> => {
        setIsLoading(true);

        try {
            await respondToInvite(notification.inviteId, accepted);

            // TODO: Remove this anti-pattern
            notification.hasResponded = true;
            setIsLoading(false);
            props.dispatch(removeNotification(notification.id));
            props.dispatch(queryConversations({
                conversationsSkip: 0,
                groupsSkip: 0,
                usersSkip: 0,
            }));

            if (accepted) {
                props.history.push({
                    pathname: "/" + notification.url
                });
            }
        } catch (err) {
            setIsLoading(false);
        }
    };

    const reject = (event: MouseEvent<HTMLButtonElement>) => {
        event.preventDefault();
        event.stopPropagation();
        respond(false);
    };

    const accept = (event: MouseEvent<HTMLButtonElement>) => {
        event.preventDefault();
        event.stopPropagation();
        respond(true);
    };

    return (
        <div className="GroupInvitationNotification">
            {!isLoading && (
                <Fragment>
                    <div className="info">
                        <Link to={`/profile/${notification.userId}`}>
                            {notification.userName}
                        </Link>
                        {notification.crossInstance && (
                            "("+notification.companyName+")"
                        )} {
                            localize("HarBjuditInDigTill")
                        } {!(notification.url && notification.hasResponded) && (
                            "\""+notification.groupName+"\""
                        )}
                        {notification.url && notification.hasResponded && (
                            <Link to={"/" + notification.url}>
                                "{notification.groupName}"
                            </Link>
                        )}.
                    </div>
                    {(!notification.hasResponded) && (
                        <div className="actions">
                            <DefaultButton onClick={reject}>
                                {localize("Avsla")}
                            </DefaultButton>
                            <PrimaryButton onClick={accept}>
                                {localize("Acceptera")}
                            </PrimaryButton>
                        </div>
                    )}
                </Fragment>
            )}
            {isLoading && (
                <Loader />
            )}
        </div>
    );
};

export default GroupInvitationNotification;
